import { useEffect, useRef } from 'react';

const useScrollAnimation = (threshold = 0.1) => {
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Add animate-in class to the main element
            entry.target.classList.add('animate-in');
            
            // Trigger fade-in animations for direct children
            const fadeElements = entry.target.querySelectorAll('.fade-in-up, .fade-in-left, .fade-in-right');
            fadeElements.forEach((element, index) => {
              setTimeout(() => {
                element.style.opacity = '1';
                element.style.transform = 'translateX(0) translateY(0)';
              }, index * 200);
            });
            
            // Add stagger animation to children
            const children = entry.target.querySelectorAll('.stagger-child');
            children.forEach((child, index) => {
              setTimeout(() => {
                child.classList.add('animate-in');
              }, index * 150);
            });
          }
        });
      },
      { threshold }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [threshold]);

  return ref;
};

export default useScrollAnimation;